const Regex = {
	password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!$#%@&!_"',\\}\\{.\]\\[<>?~`;:/+\-\\*])(?=.*[0-9]).*$/,
};

export default Regex;
